module.exports = "/lucky-balls/img/bigball/BigBall_005.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_005.png
// module id = 900
// module chunks = 0